import { Text, Dialog, Portal, CloseButton } from "@chakra-ui/react";
import { Button } from "@digital-services-gard-as/anchor-react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

type CurrencyChangeModalProps = {
    isOpen: boolean;
    onClose: () => void;
};

export const CurrencyChangeModal = ({ isOpen, onClose }: CurrencyChangeModalProps) => {
    const { t } = useTranslation("invoices");

    const handleOnOpenChange = useCallback(
        (e: { open: boolean }) => {
            if (!e.open) {
                onClose();
            }
        },
        [onClose]
    );

    return (
        <Dialog.Root open={isOpen} onOpenChange={handleOnOpenChange}>
            <Portal>
                <Dialog.Backdrop />
                <Dialog.Positioner>
                    <Dialog.Content data-testid="currencyChangeModal">
                        <Dialog.CloseTrigger asChild>
                            <CloseButton size="sm" />
                        </Dialog.CloseTrigger>
                        <Dialog.Header>
                            <Dialog.Title>{t("changeCurrencyHeader")}</Dialog.Title>
                        </Dialog.Header>
                        <Dialog.Body>
                            <Text>{t("changeCurrencyMsg")}</Text>
                        </Dialog.Body>
                        <Dialog.Footer>
                            <Button onClick={onClose} data-testid="currencyChangeModalCloseBtn">
                                {t("closeBtn")}
                            </Button>
                        </Dialog.Footer>
                    </Dialog.Content>
                </Dialog.Positioner>
            </Portal>
        </Dialog.Root>
    );
};
